import styled from "styled-components";

const SkillsContainer = styled.div`
  max-width: 100%;
  width: 160rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
  grid-gap: 2rem;
`;

export { SkillsContainer };
